import React from "react";
import { Box } from "@chakra-ui/react";

import { IChildrenProp } from "types/IChildrenProp";

interface IProps extends IChildrenProp {}

const NotificationPrototype = ({ children }: IProps) => {
  return (
    <Box mt={10} spacing={6} textAlign="center" maxW="500px" mx="auto">
      {children}
    </Box>
  );
};

export { NotificationPrototype };
